import { UnitConstants } from 'src/app/core/constants/unit';
import { ValidatorsTerms } from 'src/app/shared/validators/validators-terms';

const TERMS = ValidatorsTerms;

export class CableFields {
  public static controls = {
    title: {
      quantity: null,
      validator: TERMS.NAMES_VALIDATORS,
    },
    externalDiameter: {
      quantity: UnitConstants.QUANTITY.LENGTH,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    initialTension: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    weightDry: {
      quantity: UnitConstants.QUANTITY.FORCE_BY_LENGTH,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    weightWet: {
      quantity: UnitConstants.QUANTITY.FORCE_BY_LENGTH,
      validator: null,
    },
    stiffAxial: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.REQUIRED_SCI_NOTATION_MORE_THAN_ZERO,
    },
    stiffAxialDynamic: {
      quantity: UnitConstants.QUANTITY.FORCE,
      validator: TERMS.REQUIRED_SCI_NOTATION_AT_LEAST_ZERO,
    },
    elasticModulus: {
      quantity: UnitConstants.QUANTITY.ELASTIC_MODULE,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    morisonDrag: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    morisonInertia: {
      quantity: null,
      validator: TERMS.SCI_NOTATION_AT_LEAST_ZERO,
    },
    variableLength: {
      quantity: null,
      validator: null,
    },
    staticTimeFunctionId: {
      quantity: null,
      validator: null,
    },
    dynamicTimeFunctionId: {
      quantity: null,
      validator: null,
    },
  };
}
